import { render, staticRenderFns } from "./ChangeUserCommunity.vue?vue&type=template&id=3f4490d4&scoped=true&"
import script from "./ChangeUserCommunity.vue?vue&type=script&lang=js&"
export * from "./ChangeUserCommunity.vue?vue&type=script&lang=js&"
import style0 from "./ChangeUserCommunity.vue?vue&type=style&index=0&id=3f4490d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4490d4",
  null
  
)

export default component.exports